import {useState} from 'react'
import {useFormik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import * as libphonenumber from 'libphonenumber-js'
import {RootState} from '../store_redux'
import {hideModal} from '../store_redux/reducer/modal.reducer'

const useNotifyPrefsForm = () => {
  const rootState = useSelector((state: RootState) => state)
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const {labels, modal} = rootState

  const parsePhoneNumber = (mobile: string | null) => {
    const result = libphonenumber.parsePhoneNumberFromString(mobile || '')
    return {
      cc: result?.countryCallingCode || '',
      phone: result?.nationalNumber || '',
    } as {cc: string; phone: string}
  }

  const {email} = modal.data.notifyPrefs
  const mobile = modal.data.notifyPrefs.phone
  const {phone, cc} = parsePhoneNumber(mobile)

  const [notifyPrefs, setNotifyPrefs] = useState({
    email: !!email,
    phone: !!mobile,
    emailPrefs: !!email,
    phonePrefs: !!mobile,
  })

  const initialValues = {
    email,
    phone,
    cc,
  }

  const closeModal = () => {
    dispatch(hideModal())
  }

  const onSubmit = (values: typeof initialValues) => {
    closeModal()
  }

  const validate = (values: typeof initialValues) => {
    const errors = {} as Partial<typeof initialValues>
    if (notifyPrefs.email) {
      if (!values.email) {
        errors.email = labels.notificationModal.validationErrors.emailRequired
      } else if (
        // eslint-disable-next-line
        !/^(([a-zA-Z0-9]+([-.'!_$%&*+-\/?=^`{|}~]*)([a-zA-Z0-9])))+@(((([a-zA-Z0-9]+[a-zA-Z\-0-9]*[a-zA-Z0-9]+)|[a-zA-Z0-9])\.)+[a-zA-Z]{2,})$/i.test(
          values.email,
        )
      ) {
        errors.email = labels.notificationModal.validationErrors.emailInvalid
      }
    }

    if (notifyPrefs.phone) {
      if (!values.cc) {
        errors.cc = labels.notificationModal.validationErrors.ccRequired
      } else if (!values.phone) {
        errors.phone = labels.notificationModal.validationErrors.phoneRequired
      } else {
        const result = libphonenumber.parsePhoneNumberFromString(
          `${values.cc}${values.phone}`,
        )
        const isValid = result?.isValid()
        if (!isValid) {
          errors.phone = labels.notificationModal.validationErrors.phoneInValid
        }
      }
    }

    return errors
  }

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit,
  })

  const formatPhoneNumber = () => {
    const result = libphonenumber.parsePhoneNumberFromString(
      `${formik.values.cc}${formik.values.phone}`,
    )
    const formatted = result?.formatNational()
    return formatted || formik.values.phone
  }

  const close = () => {
    const isEmailChanged = formik.values.email !== email
    const isPhoneNumberChanged =
      `${formik.values.cc}${formik.values.phone}` !== mobile
    if (isEmailChanged || isPhoneNumberChanged) {
      setOpen(true)
    } else {
      closeModal()
    }
  }

  const closePopup = () => {
    setOpen(false)
  }

  const closeAll = () => {
    closePopup()
    closeModal()
  }

  return {
    labels,
    formik,
    notifyPrefs,
    setNotifyPrefs,
    formatPhoneNumber,
    closeAll,
    open,
    closePopup,
    close,
  }
}

export default useNotifyPrefsForm
